<template>
    <div class="p-admin-conf-consultation">
        <div class="card mb-3">
            <div class="card-header">{{ $locale.consultation_host }}予約設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <template v-if="conf.category === confCategory.consultation">
                        <div v-if="conf.value_type === confValue.int" class="m-1">
                            <div class="form-group m-form__group">
                                <label
                                    v-if="conf.is_display_name"
                                    :for="`key-${conf.key}`"
                                    class="vc-conf-name">
                                    {{ conf.name }}：
                                </label>
                                <div class="d-flex align-items-center">
                                    <span
                                        v-if="conf.text_prefix !== null"
                                        class="small text-muted mr-2">
                                        {{ conf.text_prefix }}
                                    </span>
                                    <template v-if="conf.key === 'consultation_enter_min_start' || conf.key === 'consultation_enter_min_end'">
                                        <select
                                            v-model="configurations[index].value"
                                            :id="`key-${conf.key}`"
                                            class="form-control custom-select"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            style="max-width: 100px;">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="30">30</option>
                                            <option value="40">40</option>
                                            <option value="50">50</option>
                                            <option value="60">60</option>
                                        </select>
                                    </template>
                                    <template v-else>
                                        <input
                                            v-model="configurations[index].value"
                                            :id="`key-${conf.key}`"
                                            class="form-control m-input vc-input-int"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="text">
                                    </template>
                                    <span
                                        v-if="conf.text_suffix !== null"
                                        class="small text-muted ml-2">
                                        {{ conf.text_suffix }}
                                    </span>
                                </div>
                                <p v-if="conf.desc !== null" class="small text-muted mt-1 mb-2">{{ conf.desc }}</p>
                                <div class="invalid-feedback d-block mt-1" v-if="errors[ `${index}.${helper.valueField(conf)}` ]">
                                    {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                </div>
                            </div>
                        </div>
                        <div v-else-if="conf.value_type === confValue.bool" class="m-1">
                            <div
                                class="form-group m-form__group"
                                :class="{ 'mb-0' : conf.as_check && hasFollowingConf(conf.key) }">
                                <template v-if="conf.as_check">
                                    <div class="form-check">
                                        <input
                                            v-model="configurations[index].value"
                                            value="1"
                                            :id="`key-${conf.key}_1`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="checkbox">
                                        <label
                                            :for="`key-${conf.key}_1`"
                                            class="small mb-0"
                                            style="position: relative; top: -1px; cursor: pointer;">
                                            {{ conf.name }}
                                        </label>
                                    </div>
                                </template>
                                <template v-else>
                                    <label
                                        v-if="conf.is_display_name"
                                        :for="`key-${conf.key}`"
                                        class="vc-conf-name">
                                        {{ conf.name }}：
                                    </label>
                                    <div>
                                        <div class="form-check mb-1">
                                            <input
                                                v-model="configurations[index].value"
                                                value="1"
                                                :id="`key-${conf.key}_1`"
                                                class="form-check-input"
                                                :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                                type="radio">
                                            <label
                                                :for="`key-${conf.key}_1`"
                                                style="cursor:pointer;"
                                                class="form-check-label">
                                                {{ conf.label_bool_1 }}
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input
                                                v-model="configurations[index].value"
                                                value="0"
                                                :id="`key-${conf.key}_2`"
                                                class="form-check-input"
                                                :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                                type="radio">
                                            <label
                                                :for="`key-${conf.key}_2`"
                                                style="cursor:pointer;"
                                                class="form-check-label">
                                                {{ conf.label_bool_2 }}
                                            </label>
                                        </div>
                                    </div>
                                </template>
                                <div v-if="errors[ `${index}.${helper.valueField(conf)}` ]" class="invalid-feedback d-block mt-1">
                                    {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">{{ $locale.consultation_host }}記録設定</div>
            <div class="card-body" v-if="configurations">
                <div v-for="(conf, index) in configurations">
                    <template v-if="conf.category === confCategory.medical_record">
                        <div v-if="conf.value_type === confValue.bool" class="m-1">
                            <div class="form-group m-form__group">
                                <label
                                    v-if="conf.is_display_name"
                                    :for="`key-${conf.key}`"
                                    class="vc-conf-name">
                                    {{ conf.name }}：
                                </label>
                                <div>
                                    <div class="form-check mb-1">
                                        <input
                                            v-model="configurations[index].value"
                                            value="1"
                                            :id="`key-${conf.key}_1`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_1`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_1 }}
                                        </label>
                                    </div>
                                    <div class="form-check">
                                        <input
                                            v-model="configurations[index].value"
                                            value="0"
                                            :id="`key-${conf.key}_2`"
                                            class="form-check-input"
                                            :class="{ 'is-invalid' : errors[ `${index}.${helper.valueField(conf)}` ] }"
                                            type="radio">
                                        <label
                                            :for="`key-${conf.key}_2`"
                                            style="cursor:pointer;"
                                            class="form-check-label">
                                            {{ conf.label_bool_2 }}
                                        </label>
                                    </div>
                                </div>
                                <div v-if="errors[ `${index}.${helper.valueField(conf)}` ]" class="invalid-feedback d-block mt-1">
                                    {{ errors[ `${index}.${helper.valueField(conf)}` ][0]}}
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="d-flex justify-content-end">
                    <button
                        @click="updateConfigurations"
                        :disabled="inProgress"
                        class="btn btn-yokumiru-orange btn-settings mt-3">
                        保存
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    props: {
        conf: {
            type: Array,
            required: true,
        },
    },

    data: function () {
        return {
            helper: YokumiruHelper,
            configurations: [],
            errors: {},
            inProgress: false,
            confCategory: constants.confCategory,
            confValue: constants.confValue,
        }
    },

    computed: {
        /**
         * 更新データ準備
         *
         * @return {object}
         */
        preparedConfigurations: function () {
            return this.helper.bindConfigurationsValue(this.configurations)
        },
    },

    methods: {
        /**
         * 後続に表示される設定が存在するかどうか（マージン調整用）
         *
         * @param {string} key
         * @returns {boolean}
         */
        hasFollowingConf: function (key) {
            return key !== 'reservation_cancel_after_confirm_user'
                && key !== 'consultation_allow_absence_doctor'
                && key !== 'consultation_cancel_doctor_login'
        },

        /**
         * 設定更新
         */
        updateConfigurations: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.configurations.endpoint.base

            await axios.post(endpoint, this.preparedConfigurations)
                .then(() => {
                    this.errors = {}
                    bus.$emit('alert-success', '設定を更新しました。')
                })
                .catch(({response}) => {
                    this.errors = response.data.errors
                    bus.$emit('alert-danger')
                })

            this.inProgress = false
        },
    },

    watch: {
        conf: function (conf) {
            this.configurations = conf
        },
    }
}
</script>

<style lang="scss" scoped>
    .vc-conf-name {
        color: #5f5f5f;
        font-size: 13px;
        font-weight: bold;
    }

    .vc-input-int {
        max-width: 100px;
    }
</style>
